import { render, staticRenderFns } from "./MobilePromoCard.vue?vue&type=template&id=25bce0ee&scoped=true"
import script from "./MobilePromoCard.vue?vue&type=script&lang=js"
export * from "./MobilePromoCard.vue?vue&type=script&lang=js"
import style0 from "./MobilePromoCard.vue?vue&type=style&index=0&id=25bce0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bce0ee",
  null
  
)

export default component.exports